// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3fP3w","col":"styles_col__33xYu"};